import { useEffect, useRef, useState } from 'react';

export const useScrollReveal = (options) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          obs.unobserve(entry.target);
        }
      },
      { threshold: 0.2, ...options }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [options]);

  return [ref, isVisible];
};
